import { FC } from "react";
import { Link } from "react-router-dom";
import { leveningStr } from "../../common/helper";
import { ArticleType } from "../../models/article.model";

interface IBookmarksProps {
  bookmarks: ArticleType[];
}

const Bookmarks: FC<IBookmarksProps> = ({ bookmarks }) => {
  const { length } = bookmarks;
  const showPost = length > 0 ?
    bookmarks.map(({ ID, Title, Body }, index) =>
      <div key={ID} className="blog-bookmark-item">
        <small className="text-muted">#{(index + 1)}</small>
        <h6 className="mb-1 mt-1"><Link className="blog-post-link" to={`/blog/${ID}`}>{Title}</Link></h6>
        <p className="text-muted mb-0">{leveningStr(Body, 90)}...</p>
      </div>) :
    <div className="text-muted">No bookmarks yet. Add one from a post card.</div>;
  return <div>{showPost}</div>
}

export default Bookmarks;